import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import focusable from '../../components/Focusable/Focusable'
import { platformTransitionStyle } from '../../../../shared/helpers'

class SeeMoreCarouselItem extends React.Component {
  constructor(props) {
    super(props)
    this.componentType = 'seeMoreCarouselItem'
    const header = this.props.header
    const slug = props.slug
    this.url = ''
    let url = encodeURIComponent(this.props.url)
    if (
      (props.view === 'video' &&
        !(props.header === 'Extras' && props.listHasSeasons)) ||
      props.view === 'show' ||
      props.view === 'skylab-collection'
    ) {
      this.url = `/seeall/${header}/${url}`
    } else if (props.view === 'season') {
      this.url = `/seasons/${slug}/?type=all&parent=${props.parentTitle}`
    } else if (props.header === 'Extras' && props.listHasSeasons) {
      this.url = `/seasons/${slug}/?type=extras&parent=${props.parentTitle}`
    }

    this.carouselLinkRef = React.createRef()
  }

  onKeyEvent(key) {
    let handled = false

    if ('ENTER' === key) {
      this.carouselLinkRef.current?.click()
    }

    return handled
  }

  render() {
    const { view, hasFocus } = this.props

    return (
      <Link
        to={this.url}
        className={`see-more-carousel-item ${
          view === 'video' || view === 'skylab-collection' || view === 'season'
            ? 'video-style'
            : 'show-style'
        }`}
        ref={this.carouselLinkRef}
      >
        {('video' === view ||
          'season' === view ||
          'skylab-collection' === view) && (
          <div
            className={`video-title ${hasFocus ? 'focused' : ''}`}
            alt="See All Videos"
            style={{
              transition: platformTransitionStyle(
                'transform 0.25s ease-in-out'
              ),
            }}
          >
            <span>See All</span>
          </div>
        )}
        {'show' === view && (
          <div
            className={`show-tile ${hasFocus ? 'focused' : ''}`}
            alt="See All Shows"
            style={{
              transition: platformTransitionStyle(
                'transform 0.25s ease-in-out'
              ),
            }}
          >
            <span>See All</span>
          </div>
        )}
        <p className="sr-only">See All Videos</p>
      </Link>
    )
  }
}

SeeMoreCarouselItem.propTypes = {
  hasFocus: PropTypes.bool,
  header: PropTypes.string,
  listHasSeasons: PropTypes.object,
  parentTitle: PropTypes.string,
  slug: PropTypes.string,
  url: PropTypes.string,
  view: PropTypes.string,
}

export default focusable(SeeMoreCarouselItem)
